import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, IterableDiffers, KeyValueDiffers, NgModule, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
let currentTemplateElement;
let firstVal = {};
/**
 * Internal Helpers
 */
class Utils {
    /**
     * @param {?} obj
     * @return {?}
     */
    static IterateAndGetChanges(obj) {
        if (ej.isNullOrUndefined(obj.tags) || obj.tags.length === 0) {
            return null;
        }
        let /** @type {?} */ res = {};
        for (let /** @type {?} */ i = 0, /** @type {?} */ tags = obj.tags; i < tags.length; i++) {
            let /** @type {?} */ tag = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */(obj))['tag_' + tag.replace(/\./g, '_')];
            if (!ej.isNullOrUndefined(tagElement) && tagElement.hasChanges) {
                res[tag] = tagElement.getChangesAndReset();
            }
        }
        return res;
    }
}
class BoldReportComponents {
    /**
     * @param {?} controlName
     * @param {?} el
     * @param {?} cdRef
     * @param {?} tags
     * @param {?} ejIterableDiffers
     * @param {?} _ejKeyValueDiffers
     */
    constructor(controlName, el, cdRef, tags, ejIterableDiffers, _ejKeyValueDiffers) {
        this.controlName = controlName;
        this.el = el;
        this.cdRef = cdRef;
        this.tags = tags;
        this.ejIterableDiffers = ejIterableDiffers;
        this._ejKeyValueDiffers = _ejKeyValueDiffers;
        this.model = ({});
        this.outputs = [];
        this.inputs = [];
        this.twoways = [];
        //        this.__shadow = this.dom.getShadowRoot(this.el.nativeElement);
        this.firstCheck = true;
        this.ejIterable = this.ejIterableDiffers.find([]).create(null);
        this.ejKeyValueDif = _ejKeyValueDiffers.find([]).create();
    }
    /**
     * @param {?} instance
     * @param {?} model
     * @param {?} event
     * @return {?}
     */
    static bindAndRaiseEvent(instance, model, event) {
        if (!event.startsWith('model.')) { // && instance[event]['observers'].length > 1) {
            let /** @type {?} */ originalEvt = event.startsWith('bold') ? event.substr(4) : event;
            model[originalEvt] = function (params) {
                instance[event + '_output']['emit'](params);
            };
        }
    }
    /**
     * @param {?} twoways
     * @return {?}
     */
    createTwoways(twoways) {
        if (!twoways) {
            return;
        }
        let /** @type {?} */ model = this.model;
        for (let /** @type {?} */ i = 0; i < twoways.length; i++) {
            let /** @type {?} */ element = twoways[i].replace(/\_/g, '.');
            ej.createObject(element + 'Change', ( /** @type {?} */(this))[twoways[i] + '_twoChange'], model);
            ej.createObject(element, this.addTwoways(element), model);
        }
    }
    /**
     * @param {?} prop
     * @return {?}
     */
    addTwoways(prop) {
        let /** @type {?} */ model = this.model, /** @type {?} */ value = firstVal; // , originalProp = prop.replace(/-/g, '.');
        return function (newVal, isApp) {
            if (value === firstVal) {
                value = ej.getObject(prop + '_two', model);
                if (value === undefined) {
                    value = ej.getObject(prop, this === undefined || this.defaults === undefined ? {} : this.defaults);
                }
            }
            if (newVal === undefined) {
                return value;
            }
            if (value === newVal) {
                return;
            }
            value = newVal;
            if (!isApp) {
                ej.createObject(prop + '_two', newVal, model);
                ej.getObject(prop + 'Change', model).emit(newVal);
            }
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        for (let /** @type {?} */ key in this) {
            if (key.indexOf('_input') != -1)
                this.inputs.push(key);
            if (key.indexOf('_output') != -1)
                this.outputs.push(key);
            if (key.indexOf('_two') != -1 && key.indexOf('_twoChange') == -1)
                this.twoways.push(key.replace('_two', ''));
        }
        if (ej.isNullOrUndefined(( /** @type {?} */(this))['options'])) {
            this.createTwoways(this.twoways);
        }
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.firstCheck = false;
        let /** @type {?} */ model = this.model, /** @type {?} */ events = this.outputs;
        if (events) {
            for (let /** @type {?} */ i = 0; i < events.length; i++) {
                let /** @type {?} */ event = events[i].replace('_output', '');
                BoldReportComponents.bindAndRaiseEvent(this, model, event);
            }
        }
        if (ej.isNullOrUndefined(( /** @type {?} */(this))['options'])) {
            for (let /** @type {?} */ i = 0; i < this.tags.length; i++) {
                let /** @type {?} */ element = this.tags[i], /** @type {?} */ item = ( /** @type {?} */(this))['tag_' + element.replace(/\./g, '_')];
                if (!ej.isNullOrUndefined(item)) {
                    ej.createObject(element, item.getList(), this.model);
                }
            }
            for (let /** @type {?} */ i = 0; i < this.inputs.length; i++) {
                let /** @type {?} */ property = this.inputs[i];
                let /** @type {?} */ modelProperty = this.inputs[i].replace('_input', '');
                if (( /** @type {?} */(this))[property] != null) {
                    if (modelProperty.indexOf('_') == -1) {
                        if (( /** @type {?} */(this.model))[modelProperty]) {
                            $.extend(true, ( /** @type {?} */(this.model))[modelProperty], ( /** @type {?} */(this))[property]);
                        }
                        else {
                            ( /** @type {?} */(this.model))[modelProperty] = ( /** @type {?} */(this))[property];
                        }
                    }
                    else if (modelProperty.indexOf('_two') == -1) {
                        let /** @type {?} */ tempObj = {};
                        let /** @type {?} */ key = modelProperty.replace(/\_/g, '.');
                        ej.createObject(key, ( /** @type {?} */(this))[property], tempObj);
                        let /** @type {?} */ rootProp = key.split('.')[0];
                        if (( /** @type {?} */(this.model))[rootProp] == undefined)
                            ( /** @type {?} */(this.model))[rootProp] = {};
                        $.extend(true, ( /** @type {?} */(this.model))[rootProp], tempObj[rootProp]);
                    }
                }
            }
            for (let /** @type {?} */ i = 0; i < this.twoways.length; i++) {
                let /** @type {?} */ twoway = this.twoways[i];
                let /** @type {?} */ twowayProperty = twoway + '_two';
                if (( /** @type {?} */(this))[twowayProperty] != null) {
                    if (twoway.indexOf('_') == -1) {
                        ( /** @type {?} */(this.model))[twowayProperty] = ( /** @type {?} */(this))[twowayProperty];
                    }
                    else {
                        let /** @type {?} */ tempObj = {};
                        let /** @type {?} */ key = twoway.replace(/\_/g, '.') + '_two';
                        ej.createObject(key, ( /** @type {?} */(this))[twowayProperty], tempObj);
                        let /** @type {?} */ rootProp = twowayProperty.split('_')[0];
                        $.extend(true, ( /** @type {?} */(this.model))[rootProp], tempObj[rootProp]);
                    }
                }
            }
        }
        else
            this.model = jQuery.extend(this.model, ( /** @type {?} */(this))['options']);
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (ej.isNullOrUndefined(( /** @type {?} */(this))['options'])) {
            this.twoways.forEach(element => {
                if (( /** @type {?} */(this))[element + '_two'] instanceof Array) {
                    let /** @type {?} */ changes = this.ejIterable.diff(( /** @type {?} */(this))[element + '_two']);
                    if (changes) {
                        let /** @type {?} */ ngChanges = {};
                        if (this.widget != undefined) {
                            ngChanges = this.getTwowayChanges(changes.collection, ngChanges, element.replace(/\_/g, '.'));
                            ej.createObject(element.replace(/\_/g, '.') + '.two', changes.collection, ngChanges);
                            ( /** @type {?} */(this.widget))['setModel'](ngChanges, $.isPlainObject(ngChanges));
                        }
                    }
                }
            });
        }
        else {
            let /** @type {?} */ changes = this.ejKeyValueDif.diff(( /** @type {?} */(this))['options']);
            if (changes) {
                if (this.widget != undefined) {
                    var /** @type {?} */ ngchanges = {};
                    changes.forEachChangedItem((changedprop) => {
                        ej.createObject(changedprop.key, changedprop.currentValue, ngchanges);
                    });
                    ( /** @type {?} */(this.widget))['setModel'](ngchanges, $.isPlainObject(ngchanges));
                }
            }
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        let /** @type {?} */ nativeElement = this.isEditor ? $(this.el.nativeElement.children) : $(this.el.nativeElement);
        let /** @type {?} */ controlName = this.lowerCaseFirstLetter(this.controlName);
        this.widget = ( /** @type {?} */($(nativeElement)))[controlName](this.model)[controlName]('instance');
    }
    /**
     * @param {?} string
     * @return {?}
     */
    lowerCaseFirstLetter(string) {
        return string[0].toLowerCase() + string.slice(1);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.firstCheck) {
            return;
        }
        let /** @type {?} */ ngChanges = {};
        if (ej.isNullOrUndefined(( /** @type {?} */(this))['options'])) {
            for (let /** @type {?} */ key in changes) {
                let /** @type {?} */ element = changes[key];
                if (element.previousValue === element.currentValue) {
                    break;
                }
                key = key.replace('_input', '').replace(/\_/g, '.');
                if (key.endsWith('.two')) {
                    let /** @type {?} */ oKey = key.replace('.two', '');
                    ngChanges = this.getTwowayChanges(element.currentValue, ngChanges, oKey);
                }
                ej.createObject(key, element.currentValue, ngChanges);
            }
            ( /** @type {?} */(this.widget))['setModel'](ngChanges, $.isPlainObject(ngChanges));
        }
    }
    /**
     * @param {?} value
     * @param {?} ngChanges
     * @param {?} prop
     * @return {?}
     */
    getTwowayChanges(value, ngChanges, prop) {
        let /** @type {?} */ valFn = ej.getObject(prop, ( /** @type {?} */(this.widget))['model']);
        valFn(value, true);
        ej.createObject(prop, valFn, ngChanges);
        return ngChanges;
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        // TODO: ChangeDetection Third/Multi level
        let /** @type {?} */ changes = Utils.IterateAndGetChanges(this);
        for (let /** @type {?} */ key in changes) {
            if (changes.hasOwnProperty(key)) {
                let /** @type {?} */ element = changes[key];
                ( /** @type {?} */(this.widget))['_' + key](element);
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        ( /** @type {?} */(this.widget))['destroy']();
    }
}
BoldReportComponents.ɵfac = function BoldReportComponents_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
BoldReportComponents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BoldReportComponents, features: [ɵngcc0.ɵɵNgOnChangesFeature] });

class ComplexTagElement {
    /**
     * @param {?} tags
     */
    constructor(tags) {
        this.tags = tags;
        this.valueChange = new EventEmitter();
        this.complexes = [];
        this.hasChanges = false;
        this.firstChange = true;
        Object.defineProperty(this, 'parent', {
            enumerable: false,
            writable: true,
            value: null
        });
        currentTemplateElement = this;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.firstChange = false;
        for (let /** @type {?} */ key in this) {
            if (key.indexOf('_') != -1 && key.indexOf('tag_') == -1)
                this.complexes.push(key);
        }
        for (let /** @type {?} */ i = 0; i < this.complexes.length; i++) {
            let /** @type {?} */ property = this.complexes[i];
            if (property.indexOf('_') != -1) {
                let /** @type {?} */ tempObj = {};
                let /** @type {?} */ key = property.replace(/\_/g, '.');
                ej.createObject(key, ( /** @type {?} */(this))[property], tempObj);
                let /** @type {?} */ rootProp = key.split('.')[0];
                if (( /** @type {?} */(this))[rootProp] == undefined)
                    ( /** @type {?} */(this))[rootProp] = {};
                $.extend(true, ( /** @type {?} */(this))[rootProp], tempObj[rootProp]);
            }
        }
    }
    /**
     * @return {?}
     */
    ensureCleanObject() {
        let /** @type {?} */ tags = this.tags;
        for (let /** @type {?} */ i = 0; i < tags.length; i++) {
            let /** @type {?} */ element = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */(this))['tag_' + element.replace(/\./g, '_')];
            if (i === 0 && ( /** @type {?} */(this))[element]) {
                return;
            }
            if (ej.isNullOrUndefined(tagElement)) {
                continue;
            }
            ej.createObject(element, tagElement.getList(), this);
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (this.firstChange) {
            return;
        }
        this.recentChanges = changes;
        this.hasChanges = true;
    }
    /**
     * @return {?}
     */
    getChangesAndReset() {
        if (this.hasChanges === false) {
            return;
        }
        let /** @type {?} */ changes = this.recentChanges || {};
        let /** @type {?} */ contentChanges = Utils.IterateAndGetChanges(this);
        if (!$.isEmptyObject(contentChanges)) {
            for (let /** @type {?} */ key in contentChanges) {
                if (contentChanges.hasOwnProperty(key)) {
                    let /** @type {?} */ element = contentChanges[key];
                    // this.el.nativeElement.
                    if (!ej.isNullOrUndefined(this.parent.widget['_' + this.property.replace(/\./g, '_') + '_' + key]))
                        this.parent.widget['_' + this.property.replace(/\./g, '_') + '_' + key](element);
                }
            }
        }
        this.hasChanges = false;
        return changes;
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        let /** @type {?} */ tags = this.tags;
        for (let /** @type {?} */ i = 0, /** @type {?} */ len = tags.length; i < len; i++) {
            let /** @type {?} */ element = tags[i], /** @type {?} */ tagElement = ( /** @type {?} */(this))['tag_' + element.replace(/\./g, '_')];
            if (tagElement && tagElement.hasChanges) {
                this.hasChanges = true;
            }
        }
    }
}
ComplexTagElement.ɵfac = function ComplexTagElement_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
ComplexTagElement.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ComplexTagElement, features: [ɵngcc0.ɵɵNgOnChangesFeature] });

class ArrayTagElement {
    /**
     * @param {?} propertyName
     */
    constructor(propertyName) {
        this.propertyName = propertyName;
        this.hasChanges = false;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        let /** @type {?} */ index = 0;
        this.list = this.children.map((child) => {
            child.index = index++;
            child.property = this.propertyName;
            return child;
        });
    }
    /**
     * @return {?}
     */
    getList() {
        let /** @type {?} */ list = this.list;
        for (let /** @type {?} */ i = 0; i < list.length; i++) {
            list[i].ensureCleanObject();
        }
        return list;
    }
    /**
     * @return {?}
     */
    getChangesAndReset() {
        this.hasChanges = false;
        return this.recentChanges;
    }
    /**
     * @return {?}
     */
    ngAfterContentChecked() {
        let /** @type {?} */ changes = {}, /** @type {?} */ res = ( /** @type {?} */(changes))[this.propertyName] = [], /** @type {?} */ childChange;
        for (let /** @type {?} */ i = 0, /** @type {?} */ list = this.list; i < list.length; i++) {
            let /** @type {?} */ child = list[i];
            if (child.hasChanges) {
                childChange = child.getChangesAndReset();
                if (!ej.isNullOrUndefined(childChange)) {
                    res.push(/** @type {?} */ ({
                        index: child.index,
                        change: childChange
                    }));
                }
            }
        }
        if (res.length > 0) {
            this.recentChanges = res;
            this.hasChanges = true;
        }
    }
}
ArrayTagElement.ɵfac = function ArrayTagElement_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
ArrayTagElement.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ArrayTagElement });


// tslint:disable-next-line:max-line-length
class BoldReportViewerComponent extends BoldReportComponents {
    /**
     * @param {?} el
     * @param {?} cdRef
     * @param {?} _ejIterableDiffers
     * @param {?} _ejkeyvaluediffers
     */
    constructor(el, cdRef, _ejIterableDiffers, _ejkeyvaluediffers) {
        super('BoldReportViewer', el, cdRef, [], _ejIterableDiffers, _ejkeyvaluediffers);
        this.el = el;
        this.cdRef = cdRef;
        this._ejIterableDiffers = _ejIterableDiffers;
        this._ejkeyvaluediffers = _ejkeyvaluediffers;
        this.drillThrough_output = new EventEmitter();
        this.renderingBegin_output = new EventEmitter();
        this.renderingComplete_output = new EventEmitter();
        this.reportError_output = new EventEmitter();
        this.reportExport_output = new EventEmitter();
        this.reportLoaded_output = new EventEmitter();
        this.showError_output = new EventEmitter();
        this.viewReportClick_output = new EventEmitter();
        this.ajaxBeforeLoad_output = new EventEmitter();
        this.ajaxSuccess_output = new EventEmitter();
        this.ajaxError_output = new EventEmitter();
        this.toolbarRendering_output = new EventEmitter();
        this.exportProgressChanged_output = new EventEmitter();
        this.printProgressChanged_output = new EventEmitter();
        this.exportItemClick_output = new EventEmitter();
        this.toolBarItemClick_output = new EventEmitter();
        this.hyperlink_output = new EventEmitter();
        this.reportPrint_output = new EventEmitter();
        this.beforeParameterAdd_output = new EventEmitter();
    }
}
BoldReportViewerComponent.ɵfac = function BoldReportViewerComponent_Factory(t) { return new (t || BoldReportViewerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
BoldReportViewerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BoldReportViewerComponent, selectors: [["bold-reportviewer"]], inputs: { dataSources_input: ["dataSources", "dataSources_input"], exportSettings_input: ["exportSettings", "exportSettings_input"], isResponsive_input: ["isResponsive", "isResponsive_input"], locale_input: ["locale", "locale_input"], pageSettings_input: ["pageSettings", "pageSettings_input"], parameters_input: ["parameters", "parameters_input"], toolbarSettings_input: ["toolbarSettings", "toolbarSettings_input"], parameterSettings_input: ["parameterSettings", "parameterSettings_input"], printMode_input: ["printMode", "printMode_input"], printOption_input: ["printOption", "printOption_input"], processingMode_input: ["processingMode", "processingMode_input"], renderMode_input: ["renderMode", "renderMode_input"], reportPath_input: ["reportPath", "reportPath_input"], reportServerUrl_input: ["reportServerUrl", "reportServerUrl_input"], reportServiceUrl_input: ["reportServiceUrl", "reportServiceUrl_input"], zoomFactor_input: ["zoomFactor", "zoomFactor_input"], serviceAuthorizationToken_input: ["serviceAuthorizationToken", "serviceAuthorizationToken_input"], enableParameterBlockScroller_input: ["enableParameterBlockScroller", "enableParameterBlockScroller_input"], enableDatasourceBlockScroller_input: ["enableDatasourceBlockScroller", "enableDatasourceBlockScroller_input"], sizeToReportContent_input: ["sizeToReportContent", "sizeToReportContent_input"], autoRender_input: ["autoRender", "autoRender_input"], enableNotificationBar_input: ["enableNotificationBar", "enableNotificationBar_input"], enableDropDownSearch_input: ["enableDropDownSearch", "enableDropDownSearch_input"], enableVirtualEvaluation_input: ["enableVirtualEvaluation", "enableVirtualEvaluation_input"], waitingPopupTemplate_input: ["waitingPopupTemplate", "waitingPopupTemplate_input"], dataSources_name_input: ["dataSources.name", "dataSources_name_input"], dataSources_value_input: ["dataSources.value", "dataSources_value_input"], exportSettings_exportOptions_input: ["exportSettings.exportOptions", "exportSettings_exportOptions_input"], exportSettings_excelFormat_input: ["exportSettings.excelFormat", "exportSettings_excelFormat_input"], exportSettings_wordFormat_input: ["exportSettings.wordFormat", "exportSettings_wordFormat_input"], exportSettings_customItems_input: ["exportSettings.customItems", "exportSettings_customItems_input"], exportSettings_imageQuality_input: ["exportSettings.imageQuality", "exportSettings_imageQuality_input"], pageSettings_orientation_input: ["pageSettings.orientation", "pageSettings_orientation_input"], pageSettings_paperSize_input: ["pageSettings.paperSize", "pageSettings_paperSize_input"], pageSettings_height_input: ["pageSettings.height", "pageSettings_height_input"], pageSettings_width_input: ["pageSettings.width", "pageSettings_width_input"], pageSettings_margins_input: ["pageSettings.margins", "pageSettings_margins_input"], parameters_labels_input: ["parameters.labels", "parameters_labels_input"], parameters_name_input: ["parameters.name", "parameters_name_input"], parameters_nullable_input: ["parameters.nullable", "parameters_nullable_input"], parameters_prompt_input: ["parameters.prompt", "parameters_prompt_input"], parameters_values_input: ["parameters.values", "parameters_values_input"], parameterSettings_delimiterChar_input: ["parameterSettings.delimiterChar", "parameterSettings_delimiterChar_input"], parameterSettings_popupHeight_input: ["parameterSettings.popupHeight", "parameterSettings_popupHeight_input"], parameterSettings_popupWidth_input: ["parameterSettings.popupWidth", "parameterSettings_popupWidth_input"], parameterSettings_itemWidth_input: ["parameterSettings.itemWidth", "parameterSettings_itemWidth_input"], parameterSettings_labelWidth_input: ["parameterSettings.labelWidth", "parameterSettings_labelWidth_input"], parameterSettings_minDateTime_input: ["parameterSettings.minDateTime", "parameterSettings_minDateTime_input"], parameterSettings_maxDateTime_input: ["parameterSettings.maxDateTime", "parameterSettings_maxDateTime_input"], parameterSettings_hideParameterBlock_input: ["parameterSettings.hideParameterBlock", "parameterSettings_hideParameterBlock_input"], parameterSettings_dateTimeFormat_input: ["parameterSettings.dateTimeFormat", "parameterSettings_dateTimeFormat_input"], parameterSettings_timeDisplayFormat_input: ["parameterSettings.timeDisplayFormat", "parameterSettings_timeDisplayFormat_input"], parameterSettings_timeInterval_input: ["parameterSettings.timeInterval", "parameterSettings_timeInterval_input"], parameterSettings_accessInternalValue_input: ["parameterSettings.accessInternalValue", "parameterSettings_accessInternalValue_input"], toolbarSettings_click_input: ["toolbarSettings.click", "toolbarSettings_click_input"], toolbarSettings_items_input: ["toolbarSettings.items", "toolbarSettings_items_input"], toolbarSettings_showToolbar_input: ["toolbarSettings.showToolbar", "toolbarSettings_showToolbar_input"], toolbarSettings_showTooltip_input: ["toolbarSettings.showTooltip", "toolbarSettings_showTooltip_input"], toolbarSettings_templateId_input: ["toolbarSettings.templateId", "toolbarSettings_templateId_input"], toolbarSettings_customItems_input: ["toolbarSettings.customItems", "toolbarSettings_customItems_input"], toolbarSettings_customGroups_input: ["toolbarSettings.customGroups", "toolbarSettings_customGroups_input"] }, outputs: { drillThrough_output: "drillThrough", renderingBegin_output: "renderingBegin", renderingComplete_output: "renderingComplete", reportError_output: "reportError", reportExport_output: "reportExport", reportLoaded_output: "reportLoaded", showError_output: "showError", viewReportClick_output: "viewReportClick", ajaxBeforeLoad_output: "ajaxBeforeLoad", ajaxSuccess_output: "ajaxSuccess", ajaxError_output: "ajaxError", toolbarRendering_output: "toolbarRendering", exportProgressChanged_output: "exportProgressChanged", printProgressChanged_output: "printProgressChanged", exportItemClick_output: "exportItemClick", toolBarItemClick_output: "toolBarItemClick", hyperlink_output: "hyperlink", reportPrint_output: "reportPrint", beforeParameterAdd_output: "beforeParameterAdd" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function BoldReportViewerComponent_Template(rf, ctx) { }, encapsulation: 2 });
/**
 * @nocollapse
 */
BoldReportViewerComponent.ctorParameters = () => [
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
    { type: IterableDiffers, },
    { type: KeyValueDiffers, },
];
BoldReportViewerComponent.propDecorators = {
    'dataSources_input': [{ type: Input, args: ['dataSources',] },],
    'exportSettings_input': [{ type: Input, args: ['exportSettings',] },],
    'isResponsive_input': [{ type: Input, args: ['isResponsive',] },],
    'locale_input': [{ type: Input, args: ['locale',] },],
    'pageSettings_input': [{ type: Input, args: ['pageSettings',] },],
    'parameters_input': [{ type: Input, args: ['parameters',] },],
    'toolbarSettings_input': [{ type: Input, args: ['toolbarSettings',] },],
    'parameterSettings_input': [{ type: Input, args: ['parameterSettings',] },],
    'printMode_input': [{ type: Input, args: ['printMode',] },],
    'printOption_input': [{ type: Input, args: ['printOption',] },],
    'processingMode_input': [{ type: Input, args: ['processingMode',] },],
    'renderMode_input': [{ type: Input, args: ['renderMode',] },],
    'reportPath_input': [{ type: Input, args: ['reportPath',] },],
    'reportServerUrl_input': [{ type: Input, args: ['reportServerUrl',] },],
    'reportServiceUrl_input': [{ type: Input, args: ['reportServiceUrl',] },],
    'zoomFactor_input': [{ type: Input, args: ['zoomFactor',] },],
    'serviceAuthorizationToken_input': [{ type: Input, args: ['serviceAuthorizationToken',] },],
    'enableParameterBlockScroller_input': [{ type: Input, args: ['enableParameterBlockScroller',] },],
    'enableDatasourceBlockScroller_input': [{ type: Input, args: ['enableDatasourceBlockScroller',] },],
    'sizeToReportContent_input': [{ type: Input, args: ['sizeToReportContent',] },],
    'autoRender_input': [{ type: Input, args: ['autoRender',] },],
    'enableNotificationBar_input': [{ type: Input, args: ['enableNotificationBar',] },],
    'enableDropDownSearch_input': [{ type: Input, args: ['enableDropDownSearch',] },],
    'enableVirtualEvaluation_input': [{ type: Input, args: ['enableVirtualEvaluation',] },],
    'waitingPopupTemplate_input': [{ type: Input, args: ['waitingPopupTemplate',] },],
    'dataSources_name_input': [{ type: Input, args: ['dataSources.name',] },],
    'dataSources_value_input': [{ type: Input, args: ['dataSources.value',] },],
    'exportSettings_exportOptions_input': [{ type: Input, args: ['exportSettings.exportOptions',] },],
    'exportSettings_excelFormat_input': [{ type: Input, args: ['exportSettings.excelFormat',] },],
    'exportSettings_wordFormat_input': [{ type: Input, args: ['exportSettings.wordFormat',] },],
    'exportSettings_customItems_input': [{ type: Input, args: ['exportSettings.customItems',] },],
    'exportSettings_imageQuality_input': [{ type: Input, args: ['exportSettings.imageQuality',] },],
    'pageSettings_orientation_input': [{ type: Input, args: ['pageSettings.orientation',] },],
    'pageSettings_paperSize_input': [{ type: Input, args: ['pageSettings.paperSize',] },],
    'pageSettings_height_input': [{ type: Input, args: ['pageSettings.height',] },],
    'pageSettings_width_input': [{ type: Input, args: ['pageSettings.width',] },],
    'pageSettings_margins_input': [{ type: Input, args: ['pageSettings.margins',] },],
    'parameters_labels_input': [{ type: Input, args: ['parameters.labels',] },],
    'parameters_name_input': [{ type: Input, args: ['parameters.name',] },],
    'parameters_nullable_input': [{ type: Input, args: ['parameters.nullable',] },],
    'parameters_prompt_input': [{ type: Input, args: ['parameters.prompt',] },],
    'parameters_values_input': [{ type: Input, args: ['parameters.values',] },],
    'parameterSettings_delimiterChar_input': [{ type: Input, args: ['parameterSettings.delimiterChar',] },],
    'parameterSettings_popupHeight_input': [{ type: Input, args: ['parameterSettings.popupHeight',] },],
    'parameterSettings_popupWidth_input': [{ type: Input, args: ['parameterSettings.popupWidth',] },],
    'parameterSettings_itemWidth_input': [{ type: Input, args: ['parameterSettings.itemWidth',] },],
    'parameterSettings_labelWidth_input': [{ type: Input, args: ['parameterSettings.labelWidth',] },],
    'parameterSettings_minDateTime_input': [{ type: Input, args: ['parameterSettings.minDateTime',] },],
    'parameterSettings_maxDateTime_input': [{ type: Input, args: ['parameterSettings.maxDateTime',] },],
    'parameterSettings_hideParameterBlock_input': [{ type: Input, args: ['parameterSettings.hideParameterBlock',] },],
    'parameterSettings_dateTimeFormat_input': [{ type: Input, args: ['parameterSettings.dateTimeFormat',] },],
    'parameterSettings_timeDisplayFormat_input': [{ type: Input, args: ['parameterSettings.timeDisplayFormat',] },],
    'parameterSettings_timeInterval_input': [{ type: Input, args: ['parameterSettings.timeInterval',] },],
    'parameterSettings_accessInternalValue_input': [{ type: Input, args: ['parameterSettings.accessInternalValue',] },],
    'toolbarSettings_click_input': [{ type: Input, args: ['toolbarSettings.click',] },],
    'toolbarSettings_items_input': [{ type: Input, args: ['toolbarSettings.items',] },],
    'toolbarSettings_showToolbar_input': [{ type: Input, args: ['toolbarSettings.showToolbar',] },],
    'toolbarSettings_showTooltip_input': [{ type: Input, args: ['toolbarSettings.showTooltip',] },],
    'toolbarSettings_templateId_input': [{ type: Input, args: ['toolbarSettings.templateId',] },],
    'toolbarSettings_customItems_input': [{ type: Input, args: ['toolbarSettings.customItems',] },],
    'toolbarSettings_customGroups_input': [{ type: Input, args: ['toolbarSettings.customGroups',] },],
    'drillThrough_output': [{ type: Output, args: ['drillThrough',] },],
    'renderingBegin_output': [{ type: Output, args: ['renderingBegin',] },],
    'renderingComplete_output': [{ type: Output, args: ['renderingComplete',] },],
    'reportError_output': [{ type: Output, args: ['reportError',] },],
    'reportExport_output': [{ type: Output, args: ['reportExport',] },],
    'reportLoaded_output': [{ type: Output, args: ['reportLoaded',] },],
    'showError_output': [{ type: Output, args: ['showError',] },],
    'viewReportClick_output': [{ type: Output, args: ['viewReportClick',] },],
    'ajaxBeforeLoad_output': [{ type: Output, args: ['ajaxBeforeLoad',] },],
    'ajaxSuccess_output': [{ type: Output, args: ['ajaxSuccess',] },],
    'ajaxError_output': [{ type: Output, args: ['ajaxError',] },],
    'toolbarRendering_output': [{ type: Output, args: ['toolbarRendering',] },],
    'exportProgressChanged_output': [{ type: Output, args: ['exportProgressChanged',] },],
    'printProgressChanged_output': [{ type: Output, args: ['printProgressChanged',] },],
    'exportItemClick_output': [{ type: Output, args: ['exportItemClick',] },],
    'toolBarItemClick_output': [{ type: Output, args: ['toolBarItemClick',] },],
    'hyperlink_output': [{ type: Output, args: ['hyperlink',] },],
    'reportPrint_output': [{ type: Output, args: ['reportPrint',] },],
    'beforeParameterAdd_output': [{ type: Output, args: ['beforeParameterAdd',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BoldReportViewerComponent, [{
        type: Component,
        args: [{
                selector: 'bold-reportviewer',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.IterableDiffers }, { type: ɵngcc0.KeyValueDiffers }]; }, { drillThrough_output: [{
            type: Output,
            args: ['drillThrough']
        }], renderingBegin_output: [{
            type: Output,
            args: ['renderingBegin']
        }], renderingComplete_output: [{
            type: Output,
            args: ['renderingComplete']
        }], reportError_output: [{
            type: Output,
            args: ['reportError']
        }], reportExport_output: [{
            type: Output,
            args: ['reportExport']
        }], reportLoaded_output: [{
            type: Output,
            args: ['reportLoaded']
        }], showError_output: [{
            type: Output,
            args: ['showError']
        }], viewReportClick_output: [{
            type: Output,
            args: ['viewReportClick']
        }], ajaxBeforeLoad_output: [{
            type: Output,
            args: ['ajaxBeforeLoad']
        }], ajaxSuccess_output: [{
            type: Output,
            args: ['ajaxSuccess']
        }], ajaxError_output: [{
            type: Output,
            args: ['ajaxError']
        }], toolbarRendering_output: [{
            type: Output,
            args: ['toolbarRendering']
        }], exportProgressChanged_output: [{
            type: Output,
            args: ['exportProgressChanged']
        }], printProgressChanged_output: [{
            type: Output,
            args: ['printProgressChanged']
        }], exportItemClick_output: [{
            type: Output,
            args: ['exportItemClick']
        }], toolBarItemClick_output: [{
            type: Output,
            args: ['toolBarItemClick']
        }], hyperlink_output: [{
            type: Output,
            args: ['hyperlink']
        }], reportPrint_output: [{
            type: Output,
            args: ['reportPrint']
        }], beforeParameterAdd_output: [{
            type: Output,
            args: ['beforeParameterAdd']
        }], dataSources_input: [{
            type: Input,
            args: ['dataSources']
        }], exportSettings_input: [{
            type: Input,
            args: ['exportSettings']
        }], isResponsive_input: [{
            type: Input,
            args: ['isResponsive']
        }], locale_input: [{
            type: Input,
            args: ['locale']
        }], pageSettings_input: [{
            type: Input,
            args: ['pageSettings']
        }], parameters_input: [{
            type: Input,
            args: ['parameters']
        }], toolbarSettings_input: [{
            type: Input,
            args: ['toolbarSettings']
        }], parameterSettings_input: [{
            type: Input,
            args: ['parameterSettings']
        }], printMode_input: [{
            type: Input,
            args: ['printMode']
        }], printOption_input: [{
            type: Input,
            args: ['printOption']
        }], processingMode_input: [{
            type: Input,
            args: ['processingMode']
        }], renderMode_input: [{
            type: Input,
            args: ['renderMode']
        }], reportPath_input: [{
            type: Input,
            args: ['reportPath']
        }], reportServerUrl_input: [{
            type: Input,
            args: ['reportServerUrl']
        }], reportServiceUrl_input: [{
            type: Input,
            args: ['reportServiceUrl']
        }], zoomFactor_input: [{
            type: Input,
            args: ['zoomFactor']
        }], serviceAuthorizationToken_input: [{
            type: Input,
            args: ['serviceAuthorizationToken']
        }], enableParameterBlockScroller_input: [{
            type: Input,
            args: ['enableParameterBlockScroller']
        }], enableDatasourceBlockScroller_input: [{
            type: Input,
            args: ['enableDatasourceBlockScroller']
        }], sizeToReportContent_input: [{
            type: Input,
            args: ['sizeToReportContent']
        }], autoRender_input: [{
            type: Input,
            args: ['autoRender']
        }], enableNotificationBar_input: [{
            type: Input,
            args: ['enableNotificationBar']
        }], enableDropDownSearch_input: [{
            type: Input,
            args: ['enableDropDownSearch']
        }], enableVirtualEvaluation_input: [{
            type: Input,
            args: ['enableVirtualEvaluation']
        }], waitingPopupTemplate_input: [{
            type: Input,
            args: ['waitingPopupTemplate']
        }], dataSources_name_input: [{
            type: Input,
            args: ['dataSources.name']
        }], dataSources_value_input: [{
            type: Input,
            args: ['dataSources.value']
        }], exportSettings_exportOptions_input: [{
            type: Input,
            args: ['exportSettings.exportOptions']
        }], exportSettings_excelFormat_input: [{
            type: Input,
            args: ['exportSettings.excelFormat']
        }], exportSettings_wordFormat_input: [{
            type: Input,
            args: ['exportSettings.wordFormat']
        }], exportSettings_customItems_input: [{
            type: Input,
            args: ['exportSettings.customItems']
        }], exportSettings_imageQuality_input: [{
            type: Input,
            args: ['exportSettings.imageQuality']
        }], pageSettings_orientation_input: [{
            type: Input,
            args: ['pageSettings.orientation']
        }], pageSettings_paperSize_input: [{
            type: Input,
            args: ['pageSettings.paperSize']
        }], pageSettings_height_input: [{
            type: Input,
            args: ['pageSettings.height']
        }], pageSettings_width_input: [{
            type: Input,
            args: ['pageSettings.width']
        }], pageSettings_margins_input: [{
            type: Input,
            args: ['pageSettings.margins']
        }], parameters_labels_input: [{
            type: Input,
            args: ['parameters.labels']
        }], parameters_name_input: [{
            type: Input,
            args: ['parameters.name']
        }], parameters_nullable_input: [{
            type: Input,
            args: ['parameters.nullable']
        }], parameters_prompt_input: [{
            type: Input,
            args: ['parameters.prompt']
        }], parameters_values_input: [{
            type: Input,
            args: ['parameters.values']
        }], parameterSettings_delimiterChar_input: [{
            type: Input,
            args: ['parameterSettings.delimiterChar']
        }], parameterSettings_popupHeight_input: [{
            type: Input,
            args: ['parameterSettings.popupHeight']
        }], parameterSettings_popupWidth_input: [{
            type: Input,
            args: ['parameterSettings.popupWidth']
        }], parameterSettings_itemWidth_input: [{
            type: Input,
            args: ['parameterSettings.itemWidth']
        }], parameterSettings_labelWidth_input: [{
            type: Input,
            args: ['parameterSettings.labelWidth']
        }], parameterSettings_minDateTime_input: [{
            type: Input,
            args: ['parameterSettings.minDateTime']
        }], parameterSettings_maxDateTime_input: [{
            type: Input,
            args: ['parameterSettings.maxDateTime']
        }], parameterSettings_hideParameterBlock_input: [{
            type: Input,
            args: ['parameterSettings.hideParameterBlock']
        }], parameterSettings_dateTimeFormat_input: [{
            type: Input,
            args: ['parameterSettings.dateTimeFormat']
        }], parameterSettings_timeDisplayFormat_input: [{
            type: Input,
            args: ['parameterSettings.timeDisplayFormat']
        }], parameterSettings_timeInterval_input: [{
            type: Input,
            args: ['parameterSettings.timeInterval']
        }], parameterSettings_accessInternalValue_input: [{
            type: Input,
            args: ['parameterSettings.accessInternalValue']
        }], toolbarSettings_click_input: [{
            type: Input,
            args: ['toolbarSettings.click']
        }], toolbarSettings_items_input: [{
            type: Input,
            args: ['toolbarSettings.items']
        }], toolbarSettings_showToolbar_input: [{
            type: Input,
            args: ['toolbarSettings.showToolbar']
        }], toolbarSettings_showTooltip_input: [{
            type: Input,
            args: ['toolbarSettings.showTooltip']
        }], toolbarSettings_templateId_input: [{
            type: Input,
            args: ['toolbarSettings.templateId']
        }], toolbarSettings_customItems_input: [{
            type: Input,
            args: ['toolbarSettings.customItems']
        }], toolbarSettings_customGroups_input: [{
            type: Input,
            args: ['toolbarSettings.customGroups']
        }] }); })();

class BoldReportViewerModule {
}
BoldReportViewerModule.ɵfac = function BoldReportViewerModule_Factory(t) { return new (t || BoldReportViewerModule)(); };
BoldReportViewerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BoldReportViewerModule });
BoldReportViewerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
/**
 * @nocollapse
 */
BoldReportViewerModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BoldReportViewerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BoldReportViewerComponent
                ],
                exports: [
                    BoldReportViewerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BoldReportViewerModule, { declarations: function () { return [BoldReportViewerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BoldReportViewerComponent]; } }); })();

// tslint:disable-next-line:max-line-length
class BoldReportDesignerComponent extends BoldReportComponents {
    /**
     * @param {?} el
     * @param {?} cdRef
     * @param {?} _ejIterableDiffers
     * @param {?} _ejkeyvaluediffers
     */
    constructor(el, cdRef, _ejIterableDiffers, _ejkeyvaluediffers) {
        super('BoldReportDesigner', el, cdRef, [], _ejIterableDiffers, _ejkeyvaluediffers);
        this.el = el;
        this.cdRef = cdRef;
        this._ejIterableDiffers = _ejIterableDiffers;
        this._ejkeyvaluediffers = _ejkeyvaluediffers;
        this.ajaxBeforeLoad_output = new EventEmitter();
        this.ajaxError_output = new EventEmitter();
        this.ajaxSuccess_output = new EventEmitter();
        this.create_output = new EventEmitter();
        this.destroy_output = new EventEmitter();
        this.newDataClick_output = new EventEmitter();
        this.openReportClick_output = new EventEmitter();
        this.previewReport_output = new EventEmitter();
        this.reportModified_output = new EventEmitter();
        this.reportOpened_output = new EventEmitter();
        this.reportSaved_output = new EventEmitter();
        this.saveReportClick_output = new EventEmitter();
        this.toolbarClick_output = new EventEmitter();
        this.toolbarRendering_output = new EventEmitter();
    }
}
BoldReportDesignerComponent.ɵfac = function BoldReportDesignerComponent_Factory(t) { return new (t || BoldReportDesignerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers)); };
BoldReportDesignerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BoldReportDesignerComponent, selectors: [["bold-reportdesigner"]], inputs: { configurePaneSettings_input: ["configurePaneSettings", "configurePaneSettings_input"], disableCodeModule_input: ["disableCodeModule", "disableCodeModule_input"], enableImpersonate_input: ["enableImpersonate", "enableImpersonate_input"], enableImageBlobing_input: ["enableImageBlobing", "enableImageBlobing_input"], filterDataConnectors_input: ["filterDataConnectors", "filterDataConnectors_input"], filterReportItems_input: ["filterReportItems", "filterReportItems_input"], fontNames_input: ["fontNames", "fontNames_input"], locale_input: ["locale", "locale_input"], permissionSettings_input: ["permissionSettings", "permissionSettings_input"], previewOptions_input: ["previewOptions", "previewOptions_input"], reportDataExtensions_input: ["reportDataExtensions", "reportDataExtensions_input"], reportItemExtensions_input: ["reportItemExtensions", "reportItemExtensions_input"], reportPath_input: ["reportPath", "reportPath_input"], reportVersion_input: ["reportVersion", "reportVersion_input"], reportType_input: ["reportType", "reportType_input"], reportServerUrl_input: ["reportServerUrl", "reportServerUrl_input"], serviceAuthorizationToken_input: ["serviceAuthorizationToken", "serviceAuthorizationToken_input"], serviceUrl_input: ["serviceUrl", "serviceUrl_input"], toolbarSettings_input: ["toolbarSettings", "toolbarSettings_input"], waitingPopupTemplate_input: ["waitingPopupTemplate", "waitingPopupTemplate_input"], dataTabIndex_input: ["dataTabIndex", "dataTabIndex_input"], configurePaneSettings_items_input: ["configurePaneSettings.items", "configurePaneSettings_items_input"], configurePaneSettings_showPane_input: ["configurePaneSettings.showPane", "configurePaneSettings_showPane_input"], dataSources_name_input: ["dataSources.name", "dataSources_name_input"], dataSources_value_input: ["dataSources.value", "dataSources_value_input"], exportSettings_exportOptions_input: ["exportSettings.exportOptions", "exportSettings_exportOptions_input"], exportSettings_excelFormat_input: ["exportSettings.excelFormat", "exportSettings_excelFormat_input"], exportSettings_wordFormat_input: ["exportSettings.wordFormat", "exportSettings_wordFormat_input"], exportSettings_customItems_input: ["exportSettings.customItems", "exportSettings_customItems_input"], pageSettings_orientation_input: ["pageSettings.orientation", "pageSettings_orientation_input"], pageSettings_paperSize_input: ["pageSettings.paperSize", "pageSettings_paperSize_input"], pageSettings_height_input: ["pageSettings.height", "pageSettings_height_input"], pageSettings_width_input: ["pageSettings.width", "pageSettings_width_input"], pageSettings_margins_input: ["pageSettings.margins", "pageSettings_margins_input"], parameters_labels_input: ["parameters.labels", "parameters_labels_input"], parameters_name_input: ["parameters.name", "parameters_name_input"], parameters_nullable_input: ["parameters.nullable", "parameters_nullable_input"], parameters_prompt_input: ["parameters.prompt", "parameters_prompt_input"], parameters_values_input: ["parameters.values", "parameters_values_input"], parameterSettings_delimiterChar_input: ["parameterSettings.delimiterChar", "parameterSettings_delimiterChar_input"], parameterSettings_popupHeight_input: ["parameterSettings.popupHeight", "parameterSettings_popupHeight_input"], parameterSettings_popupWidth_input: ["parameterSettings.popupWidth", "parameterSettings_popupWidth_input"], parameterSettings_itemWidth_input: ["parameterSettings.itemWidth", "parameterSettings_itemWidth_input"], parameterSettings_labelWidth_input: ["parameterSettings.labelWidth", "parameterSettings_labelWidth_input"], permissionSettings_dataSet_input: ["permissionSettings.dataSet", "permissionSettings_dataSet_input"], permissionSettings_dataSource_input: ["permissionSettings.dataSource", "permissionSettings_dataSource_input"], previewOptions_dataSources_input: ["previewOptions.dataSources", "previewOptions_dataSources_input"], previewOptions_enableParameterBlockScroller_input: ["previewOptions.enableParameterBlockScroller", "previewOptions_enableParameterBlockScroller_input"], previewOptions_enableDatasourceBlockScroller_input: ["previewOptions.enableDatasourceBlockScroller", "previewOptions_enableDatasourceBlockScroller_input"], previewOptions_enableDropDownSearch_input: ["previewOptions.enableDropDownSearch", "previewOptions_enableDropDownSearch_input"], previewOptions_exportSettings_input: ["previewOptions.exportSettings", "previewOptions_exportSettings_input"], previewOptions_pageSettings_input: ["previewOptions.pageSettings", "previewOptions_pageSettings_input"], previewOptions_parameters_input: ["previewOptions.parameters", "previewOptions_parameters_input"], previewOptions_parameterSettings_input: ["previewOptions.parameterSettings", "previewOptions_parameterSettings_input"], previewOptions_printMode_input: ["previewOptions.printMode", "previewOptions_printMode_input"], previewOptions_printOption_input: ["previewOptions.printOption", "previewOptions_printOption_input"], previewOptions_toolbarSettings_input: ["previewOptions.toolbarSettings", "previewOptions_toolbarSettings_input"], previewOptions_zoomFactor_input: ["previewOptions.zoomFactor", "previewOptions_zoomFactor_input"], reportDataExtensions_name_input: ["reportDataExtensions.name", "reportDataExtensions_name_input"], reportDataExtensions_className_input: ["reportDataExtensions.className", "reportDataExtensions_className_input"], reportDataExtensions_imageClass_input: ["reportDataExtensions.imageClass", "reportDataExtensions_imageClass_input"], reportDataExtensions_displayName_input: ["reportDataExtensions.displayName", "reportDataExtensions_displayName_input"], reportItemExtensions_name_input: ["reportItemExtensions.name", "reportItemExtensions_name_input"], reportItemExtensions_className_input: ["reportItemExtensions.className", "reportItemExtensions_className_input"], reportItemExtensions_imageClass_input: ["reportItemExtensions.imageClass", "reportItemExtensions_imageClass_input"], reportItemExtensions_displayName_input: ["reportItemExtensions.displayName", "reportItemExtensions_displayName_input"], reportItemExtensions_category_input: ["reportItemExtensions.category", "reportItemExtensions_category_input"], reportItemExtensions_toolTip_input: ["reportItemExtensions.toolTip", "reportItemExtensions_toolTip_input"], toolbarSettings_items_input: ["toolbarSettings.items", "toolbarSettings_items_input"], toolbarSettings_showToolbar_input: ["toolbarSettings.showToolbar", "toolbarSettings_showToolbar_input"], toolbarSettings_templateId_input: ["toolbarSettings.templateId", "toolbarSettings_templateId_input"] }, outputs: { ajaxBeforeLoad_output: "ajaxBeforeLoad", ajaxError_output: "ajaxError", ajaxSuccess_output: "ajaxSuccess", create_output: "create", destroy_output: "destroy", newDataClick_output: "newDataClick", openReportClick_output: "openReportClick", previewReport_output: "previewReport", reportModified_output: "reportModified", reportOpened_output: "reportOpened", reportSaved_output: "reportSaved", saveReportClick_output: "saveReportClick", toolbarClick_output: "toolbarClick", toolbarRendering_output: "toolbarRendering" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function BoldReportDesignerComponent_Template(rf, ctx) { }, encapsulation: 2 });
/**
 * @nocollapse
 */
BoldReportDesignerComponent.ctorParameters = () => [
    { type: ElementRef, },
    { type: ChangeDetectorRef, },
    { type: IterableDiffers, },
    { type: KeyValueDiffers, },
];
BoldReportDesignerComponent.propDecorators = {
    'configurePaneSettings_input': [{ type: Input, args: ['configurePaneSettings',] },],
    'disableCodeModule_input': [{ type: Input, args: ['disableCodeModule',] },],
    'enableImpersonate_input': [{ type: Input, args: ['enableImpersonate',] },],
    'enableImageBlobing_input': [{ type: Input, args: ['enableImageBlobing',] },],
    'filterDataConnectors_input': [{ type: Input, args: ['filterDataConnectors',] },],
    'filterReportItems_input': [{ type: Input, args: ['filterReportItems',] },],
    'fontNames_input': [{ type: Input, args: ['fontNames',] },],
    'locale_input': [{ type: Input, args: ['locale',] },],
    'permissionSettings_input': [{ type: Input, args: ['permissionSettings',] },],
    'previewOptions_input': [{ type: Input, args: ['previewOptions',] },],
    'reportDataExtensions_input': [{ type: Input, args: ['reportDataExtensions',] },],
    'reportItemExtensions_input': [{ type: Input, args: ['reportItemExtensions',] },],
    'reportPath_input': [{ type: Input, args: ['reportPath',] },],
    'reportVersion_input': [{ type: Input, args: ['reportVersion',] },],
    'reportType_input': [{ type: Input, args: ['reportType',] },],
    'reportServerUrl_input': [{ type: Input, args: ['reportServerUrl',] },],
    'serviceAuthorizationToken_input': [{ type: Input, args: ['serviceAuthorizationToken',] },],
    'serviceUrl_input': [{ type: Input, args: ['serviceUrl',] },],
    'toolbarSettings_input': [{ type: Input, args: ['toolbarSettings',] },],
    'waitingPopupTemplate_input': [{ type: Input, args: ['waitingPopupTemplate',] },],
    'dataTabIndex_input': [{ type: Input, args: ['dataTabIndex',] },],
    'configurePaneSettings_items_input': [{ type: Input, args: ['configurePaneSettings.items',] },],
    'configurePaneSettings_showPane_input': [{ type: Input, args: ['configurePaneSettings.showPane',] },],
    'dataSources_name_input': [{ type: Input, args: ['dataSources.name',] },],
    'dataSources_value_input': [{ type: Input, args: ['dataSources.value',] },],
    'exportSettings_exportOptions_input': [{ type: Input, args: ['exportSettings.exportOptions',] },],
    'exportSettings_excelFormat_input': [{ type: Input, args: ['exportSettings.excelFormat',] },],
    'exportSettings_wordFormat_input': [{ type: Input, args: ['exportSettings.wordFormat',] },],
    'exportSettings_customItems_input': [{ type: Input, args: ['exportSettings.customItems',] },],
    'pageSettings_orientation_input': [{ type: Input, args: ['pageSettings.orientation',] },],
    'pageSettings_paperSize_input': [{ type: Input, args: ['pageSettings.paperSize',] },],
    'pageSettings_height_input': [{ type: Input, args: ['pageSettings.height',] },],
    'pageSettings_width_input': [{ type: Input, args: ['pageSettings.width',] },],
    'pageSettings_margins_input': [{ type: Input, args: ['pageSettings.margins',] },],
    'parameters_labels_input': [{ type: Input, args: ['parameters.labels',] },],
    'parameters_name_input': [{ type: Input, args: ['parameters.name',] },],
    'parameters_nullable_input': [{ type: Input, args: ['parameters.nullable',] },],
    'parameters_prompt_input': [{ type: Input, args: ['parameters.prompt',] },],
    'parameters_values_input': [{ type: Input, args: ['parameters.values',] },],
    'parameterSettings_delimiterChar_input': [{ type: Input, args: ['parameterSettings.delimiterChar',] },],
    'parameterSettings_popupHeight_input': [{ type: Input, args: ['parameterSettings.popupHeight',] },],
    'parameterSettings_popupWidth_input': [{ type: Input, args: ['parameterSettings.popupWidth',] },],
    'parameterSettings_itemWidth_input': [{ type: Input, args: ['parameterSettings.itemWidth',] },],
    'parameterSettings_labelWidth_input': [{ type: Input, args: ['parameterSettings.labelWidth',] },],
    'permissionSettings_dataSet_input': [{ type: Input, args: ['permissionSettings.dataSet',] },],
    'permissionSettings_dataSource_input': [{ type: Input, args: ['permissionSettings.dataSource',] },],
    'previewOptions_dataSources_input': [{ type: Input, args: ['previewOptions.dataSources',] },],
    'previewOptions_enableParameterBlockScroller_input': [{ type: Input, args: ['previewOptions.enableParameterBlockScroller',] },],
    'previewOptions_enableDatasourceBlockScroller_input': [{ type: Input, args: ['previewOptions.enableDatasourceBlockScroller',] },],
    'previewOptions_enableDropDownSearch_input': [{ type: Input, args: ['previewOptions.enableDropDownSearch',] },],
    'previewOptions_exportSettings_input': [{ type: Input, args: ['previewOptions.exportSettings',] },],
    'previewOptions_pageSettings_input': [{ type: Input, args: ['previewOptions.pageSettings',] },],
    'previewOptions_parameters_input': [{ type: Input, args: ['previewOptions.parameters',] },],
    'previewOptions_parameterSettings_input': [{ type: Input, args: ['previewOptions.parameterSettings',] },],
    'previewOptions_printMode_input': [{ type: Input, args: ['previewOptions.printMode',] },],
    'previewOptions_printOption_input': [{ type: Input, args: ['previewOptions.printOption',] },],
    'previewOptions_toolbarSettings_input': [{ type: Input, args: ['previewOptions.toolbarSettings',] },],
    'previewOptions_zoomFactor_input': [{ type: Input, args: ['previewOptions.zoomFactor',] },],
    'reportDataExtensions_name_input': [{ type: Input, args: ['reportDataExtensions.name',] },],
    'reportDataExtensions_className_input': [{ type: Input, args: ['reportDataExtensions.className',] },],
    'reportDataExtensions_imageClass_input': [{ type: Input, args: ['reportDataExtensions.imageClass',] },],
    'reportDataExtensions_displayName_input': [{ type: Input, args: ['reportDataExtensions.displayName',] },],
    'reportItemExtensions_name_input': [{ type: Input, args: ['reportItemExtensions.name',] },],
    'reportItemExtensions_className_input': [{ type: Input, args: ['reportItemExtensions.className',] },],
    'reportItemExtensions_imageClass_input': [{ type: Input, args: ['reportItemExtensions.imageClass',] },],
    'reportItemExtensions_displayName_input': [{ type: Input, args: ['reportItemExtensions.displayName',] },],
    'reportItemExtensions_category_input': [{ type: Input, args: ['reportItemExtensions.category',] },],
    'reportItemExtensions_toolTip_input': [{ type: Input, args: ['reportItemExtensions.toolTip',] },],
    'toolbarSettings_items_input': [{ type: Input, args: ['toolbarSettings.items',] },],
    'toolbarSettings_showToolbar_input': [{ type: Input, args: ['toolbarSettings.showToolbar',] },],
    'toolbarSettings_templateId_input': [{ type: Input, args: ['toolbarSettings.templateId',] },],
    'ajaxBeforeLoad_output': [{ type: Output, args: ['ajaxBeforeLoad',] },],
    'ajaxError_output': [{ type: Output, args: ['ajaxError',] },],
    'ajaxSuccess_output': [{ type: Output, args: ['ajaxSuccess',] },],
    'create_output': [{ type: Output, args: ['create',] },],
    'destroy_output': [{ type: Output, args: ['destroy',] },],
    'newDataClick_output': [{ type: Output, args: ['newDataClick',] },],
    'openReportClick_output': [{ type: Output, args: ['openReportClick',] },],
    'previewReport_output': [{ type: Output, args: ['previewReport',] },],
    'reportModified_output': [{ type: Output, args: ['reportModified',] },],
    'reportOpened_output': [{ type: Output, args: ['reportOpened',] },],
    'reportSaved_output': [{ type: Output, args: ['reportSaved',] },],
    'saveReportClick_output': [{ type: Output, args: ['saveReportClick',] },],
    'toolbarClick_output': [{ type: Output, args: ['toolbarClick',] },],
    'toolbarRendering_output': [{ type: Output, args: ['toolbarRendering',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BoldReportDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'bold-reportdesigner',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.IterableDiffers }, { type: ɵngcc0.KeyValueDiffers }]; }, { ajaxBeforeLoad_output: [{
            type: Output,
            args: ['ajaxBeforeLoad']
        }], ajaxError_output: [{
            type: Output,
            args: ['ajaxError']
        }], ajaxSuccess_output: [{
            type: Output,
            args: ['ajaxSuccess']
        }], create_output: [{
            type: Output,
            args: ['create']
        }], destroy_output: [{
            type: Output,
            args: ['destroy']
        }], newDataClick_output: [{
            type: Output,
            args: ['newDataClick']
        }], openReportClick_output: [{
            type: Output,
            args: ['openReportClick']
        }], previewReport_output: [{
            type: Output,
            args: ['previewReport']
        }], reportModified_output: [{
            type: Output,
            args: ['reportModified']
        }], reportOpened_output: [{
            type: Output,
            args: ['reportOpened']
        }], reportSaved_output: [{
            type: Output,
            args: ['reportSaved']
        }], saveReportClick_output: [{
            type: Output,
            args: ['saveReportClick']
        }], toolbarClick_output: [{
            type: Output,
            args: ['toolbarClick']
        }], toolbarRendering_output: [{
            type: Output,
            args: ['toolbarRendering']
        }], configurePaneSettings_input: [{
            type: Input,
            args: ['configurePaneSettings']
        }], disableCodeModule_input: [{
            type: Input,
            args: ['disableCodeModule']
        }], enableImpersonate_input: [{
            type: Input,
            args: ['enableImpersonate']
        }], enableImageBlobing_input: [{
            type: Input,
            args: ['enableImageBlobing']
        }], filterDataConnectors_input: [{
            type: Input,
            args: ['filterDataConnectors']
        }], filterReportItems_input: [{
            type: Input,
            args: ['filterReportItems']
        }], fontNames_input: [{
            type: Input,
            args: ['fontNames']
        }], locale_input: [{
            type: Input,
            args: ['locale']
        }], permissionSettings_input: [{
            type: Input,
            args: ['permissionSettings']
        }], previewOptions_input: [{
            type: Input,
            args: ['previewOptions']
        }], reportDataExtensions_input: [{
            type: Input,
            args: ['reportDataExtensions']
        }], reportItemExtensions_input: [{
            type: Input,
            args: ['reportItemExtensions']
        }], reportPath_input: [{
            type: Input,
            args: ['reportPath']
        }], reportVersion_input: [{
            type: Input,
            args: ['reportVersion']
        }], reportType_input: [{
            type: Input,
            args: ['reportType']
        }], reportServerUrl_input: [{
            type: Input,
            args: ['reportServerUrl']
        }], serviceAuthorizationToken_input: [{
            type: Input,
            args: ['serviceAuthorizationToken']
        }], serviceUrl_input: [{
            type: Input,
            args: ['serviceUrl']
        }], toolbarSettings_input: [{
            type: Input,
            args: ['toolbarSettings']
        }], waitingPopupTemplate_input: [{
            type: Input,
            args: ['waitingPopupTemplate']
        }], dataTabIndex_input: [{
            type: Input,
            args: ['dataTabIndex']
        }], configurePaneSettings_items_input: [{
            type: Input,
            args: ['configurePaneSettings.items']
        }], configurePaneSettings_showPane_input: [{
            type: Input,
            args: ['configurePaneSettings.showPane']
        }], dataSources_name_input: [{
            type: Input,
            args: ['dataSources.name']
        }], dataSources_value_input: [{
            type: Input,
            args: ['dataSources.value']
        }], exportSettings_exportOptions_input: [{
            type: Input,
            args: ['exportSettings.exportOptions']
        }], exportSettings_excelFormat_input: [{
            type: Input,
            args: ['exportSettings.excelFormat']
        }], exportSettings_wordFormat_input: [{
            type: Input,
            args: ['exportSettings.wordFormat']
        }], exportSettings_customItems_input: [{
            type: Input,
            args: ['exportSettings.customItems']
        }], pageSettings_orientation_input: [{
            type: Input,
            args: ['pageSettings.orientation']
        }], pageSettings_paperSize_input: [{
            type: Input,
            args: ['pageSettings.paperSize']
        }], pageSettings_height_input: [{
            type: Input,
            args: ['pageSettings.height']
        }], pageSettings_width_input: [{
            type: Input,
            args: ['pageSettings.width']
        }], pageSettings_margins_input: [{
            type: Input,
            args: ['pageSettings.margins']
        }], parameters_labels_input: [{
            type: Input,
            args: ['parameters.labels']
        }], parameters_name_input: [{
            type: Input,
            args: ['parameters.name']
        }], parameters_nullable_input: [{
            type: Input,
            args: ['parameters.nullable']
        }], parameters_prompt_input: [{
            type: Input,
            args: ['parameters.prompt']
        }], parameters_values_input: [{
            type: Input,
            args: ['parameters.values']
        }], parameterSettings_delimiterChar_input: [{
            type: Input,
            args: ['parameterSettings.delimiterChar']
        }], parameterSettings_popupHeight_input: [{
            type: Input,
            args: ['parameterSettings.popupHeight']
        }], parameterSettings_popupWidth_input: [{
            type: Input,
            args: ['parameterSettings.popupWidth']
        }], parameterSettings_itemWidth_input: [{
            type: Input,
            args: ['parameterSettings.itemWidth']
        }], parameterSettings_labelWidth_input: [{
            type: Input,
            args: ['parameterSettings.labelWidth']
        }], permissionSettings_dataSet_input: [{
            type: Input,
            args: ['permissionSettings.dataSet']
        }], permissionSettings_dataSource_input: [{
            type: Input,
            args: ['permissionSettings.dataSource']
        }], previewOptions_dataSources_input: [{
            type: Input,
            args: ['previewOptions.dataSources']
        }], previewOptions_enableParameterBlockScroller_input: [{
            type: Input,
            args: ['previewOptions.enableParameterBlockScroller']
        }], previewOptions_enableDatasourceBlockScroller_input: [{
            type: Input,
            args: ['previewOptions.enableDatasourceBlockScroller']
        }], previewOptions_enableDropDownSearch_input: [{
            type: Input,
            args: ['previewOptions.enableDropDownSearch']
        }], previewOptions_exportSettings_input: [{
            type: Input,
            args: ['previewOptions.exportSettings']
        }], previewOptions_pageSettings_input: [{
            type: Input,
            args: ['previewOptions.pageSettings']
        }], previewOptions_parameters_input: [{
            type: Input,
            args: ['previewOptions.parameters']
        }], previewOptions_parameterSettings_input: [{
            type: Input,
            args: ['previewOptions.parameterSettings']
        }], previewOptions_printMode_input: [{
            type: Input,
            args: ['previewOptions.printMode']
        }], previewOptions_printOption_input: [{
            type: Input,
            args: ['previewOptions.printOption']
        }], previewOptions_toolbarSettings_input: [{
            type: Input,
            args: ['previewOptions.toolbarSettings']
        }], previewOptions_zoomFactor_input: [{
            type: Input,
            args: ['previewOptions.zoomFactor']
        }], reportDataExtensions_name_input: [{
            type: Input,
            args: ['reportDataExtensions.name']
        }], reportDataExtensions_className_input: [{
            type: Input,
            args: ['reportDataExtensions.className']
        }], reportDataExtensions_imageClass_input: [{
            type: Input,
            args: ['reportDataExtensions.imageClass']
        }], reportDataExtensions_displayName_input: [{
            type: Input,
            args: ['reportDataExtensions.displayName']
        }], reportItemExtensions_name_input: [{
            type: Input,
            args: ['reportItemExtensions.name']
        }], reportItemExtensions_className_input: [{
            type: Input,
            args: ['reportItemExtensions.className']
        }], reportItemExtensions_imageClass_input: [{
            type: Input,
            args: ['reportItemExtensions.imageClass']
        }], reportItemExtensions_displayName_input: [{
            type: Input,
            args: ['reportItemExtensions.displayName']
        }], reportItemExtensions_category_input: [{
            type: Input,
            args: ['reportItemExtensions.category']
        }], reportItemExtensions_toolTip_input: [{
            type: Input,
            args: ['reportItemExtensions.toolTip']
        }], toolbarSettings_items_input: [{
            type: Input,
            args: ['toolbarSettings.items']
        }], toolbarSettings_showToolbar_input: [{
            type: Input,
            args: ['toolbarSettings.showToolbar']
        }], toolbarSettings_templateId_input: [{
            type: Input,
            args: ['toolbarSettings.templateId']
        }] }); })();

class BoldReportDesignerModule {
}
BoldReportDesignerModule.ɵfac = function BoldReportDesignerModule_Factory(t) { return new (t || BoldReportDesignerModule)(); };
BoldReportDesignerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BoldReportDesignerModule });
BoldReportDesignerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
/**
 * @nocollapse
 */
BoldReportDesignerModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BoldReportDesignerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BoldReportDesignerComponent
                ],
                exports: [
                    BoldReportDesignerComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BoldReportDesignerModule, { declarations: function () { return [BoldReportDesignerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BoldReportDesignerComponent]; } }); })();

class BoldReportsModule {
}
BoldReportsModule.ɵfac = function BoldReportsModule_Factory(t) { return new (t || BoldReportsModule)(); };
BoldReportsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BoldReportsModule });
BoldReportsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        BoldReportViewerModule,
        BoldReportDesignerModule, BoldReportViewerModule, BoldReportDesignerModule] });
/**
 * @nocollapse
 */
BoldReportsModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BoldReportsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BoldReportViewerModule,
                    BoldReportDesignerModule
                ],
                declarations: [],
                exports: [
                    BoldReportViewerModule,
                    BoldReportDesignerModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BoldReportsModule, { imports: function () { return [CommonModule, BoldReportViewerModule, BoldReportDesignerModule]; }, exports: function () { return [BoldReportViewerModule, BoldReportDesignerModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BoldReportViewerModule, BoldReportDesignerModule, BoldReportsModule, currentTemplateElement, Utils, BoldReportComponents, ComplexTagElement, ArrayTagElement, BoldReportDesignerComponent as ɵb, BoldReportViewerComponent as ɵa };
export { ContentChild, Type, forwardRef } from '@angular/core';

